module.exports = __webpack_public_path__ + "img/FAR4_600x505.a01e083d.jpg";